import React from 'react'

import BasicRoute from 'components/routes/BasicRoute'

import InsumoConsulta from 'entity/Insumo/components/InsumoConsulta'
import InsumoForm from 'entity/Insumo/components/InsumoForm'

export default function index() {
    return (
        <>
            <BasicRoute
                perfilAuth={['r9jrEQXznNgjrZTGCfch', 'RECT03jkyTQW9B2OMz47']}//admin ou tecnico
                uid="consulta-insumo"
                route="consulta-insumo"

                menuProps={{
                    text: "Insumos",
                    sequence: "111115",
                    iconName: "Category",

                    parent: {
                        uid: "parentCadastros",
                        text: "Cadastros",
                        sequence: "222222",
                        iconName: 'Edit'
                    }
                }}

                element={<InsumoConsulta />}
            />
            <BasicRoute
                uid="insumo"
                route="_insumo"
                element={<InsumoForm />}
            />
        </>
    )
}
